window.SP = window.SP ?? {};
// @ts-ignore
window.SP.env = window.SP.env ?? {};
// @ts-ignore
window.SP.styleguide = false;
window.SP.env.rpcPortUrl = '/WEB-IES/sitekit-module/php/SP/SiteKit/Rpc/Server/Port.php';
